<template>
  <v-container class="none-fluid">
    <banner>Research Areas</banner>
    <ul class="custom-tab">
      <li
        v-for="(area, i) in areas"
        v-on:click="setActive(i)"
        :key="area.id"
        :class="{ active: isActive(i) }"
      >
        {{ area.title }}
      </li>
    </ul>
    <v-divider></v-divider>
    <div class="area-container" v-if="areas[activeIdx]">
      <p v-html="$sanitize(areas[activeIdx].content)"></p>

      <v-expansion-panels v-model="panel" multiple>
        <v-expansion-panel
          v-if="areas[activeIdx].projects.length"
          key="project"
          expand
        >
          <v-expansion-panel-header class="expansion-header">
            Current Projects
          </v-expansion-panel-header>
          <v-expansion-panel-content class="expansion-content">
            <v-row>
              <v-col
                v-for="project in areas[activeIdx].projects"
                :key="project.id"
                cols="12"
                sm="6"
                md="4"
              >
                <v-hover v-slot="{ hover }">
                  <v-card class="mx-auto" :href="'/project?id=' + project.id">
                    <v-img
                      contain
                      class="white--text align-end"
                      height="300px"
                      :src="
                        project.thumbnail ||
                        'https://firebasestorage.googleapis.com/v0/b/uscinteractionlab.appspot.com/o/projects%2Fproject_placeholder.png?alt=media&token=76d05851-6808-4854-a317-1b0c81da9506'
                      "
                    >
                      <v-expand-transition>
                        <div
                          v-if="hover"
                          class="d-flex transition-fast-in-fast-out v-card--reveal caption"
                          style="height: 100%"
                        >
                          {{ project.summary }}
                        </div>
                      </v-expand-transition>
                    </v-img>

                    <v-card-text class="project-text">
                      {{ project.title }}
                    </v-card-text>
                  </v-card>
                </v-hover>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel
          v-if="areas[activeIdx].pastProjects.length"
          key="past project"
          expand
        >
          <v-expansion-panel-header class="expansion-header">
            Past Projects
          </v-expansion-panel-header>
          <v-expansion-panel-content class="expansion-content">
            <div
              v-for="project in areas[activeIdx].pastProjects"
              :key="project.id"
              class="expansion-subsection"
            >
              <a
                class="link"
                :href="
                  project.externalLink
                    ? project.externalLink
                    : '/project?id=' + project.id
                "
              >
                {{ project.title }}
              </a>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
  </v-container>
</template>

<script>
import { getAllAreas } from "../../service/research/areas";
import { getProjectLists } from "../../service/research/projects";
import Banner from "../global/Banner";

export default {
  components: {
    Banner,
  },
  data() {
    return {
      activeIdx: 0,
      areas: [],
      panel: [0],
    };
  },
  mounted() {
    getAllAreas()
      .then(async (data) => {
        this.areas = await Promise.all(
          data.map(async (area) => {
            const { projects, pastProjects } = await getProjectLists(
              "areas",
              area.id
            );
            return { ...area, projects, pastProjects };
          })
        );
      })
      .catch((err) => {
        console.error(err.message);
      });
  },
  methods: {
    isActive: function (idx) {
      return idx === this.activeIdx;
    },
    setActive: function (idx) {
      this.activeIdx = idx;
    },
  },
};
</script>

<style scoped lang="scss">
.area-container > p,
h2 {
  margin: 15px 0px;
}
</style>
